"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 4H2.01L2 20h20zm-2 14H4v-6h16zm0-10H4V6h16z"
}), 'CreditCardSharp');